import moment from 'moment-timezone';
import { toOption, toOptionsConstructor } from '@client/new/helpers/types';

export const timezoneValues = [
  'America/New_York',
  'America/Los_Angeles',
  'Europe/Berlin',
  'Europe/London',
  'Asia/Shanghai',
  'Asia/Tokyo',
  'Australia/Sydney',
] as const;

type Timezone = (typeof timezoneValues)[number];

const tz = toOptionsConstructor<Timezone>();

export const timezoneOptions = [
  tz('America/New_York', 'New York (EST)'),
  tz('America/Los_Angeles', 'San Francisco (PST)'),
  tz('Europe/Berlin', 'Berlin (CET)'),
  tz('Europe/London', 'London (GMT)'),
  tz('Asia/Shanghai', 'Shanghai (CST)'),
  tz('Asia/Tokyo', 'Tokyo (JST)'),
  tz('Australia/Sydney', 'Sydney (AEDT)'),
];

export const dayTimeValues = ['AM', 'PM'] as const;
type DayTime = (typeof dayTimeValues)[number];

export const dayTimeOptions = [
  toOption<DayTime>('AM', 'AM'),
  toOption<DayTime>('PM', 'PM'),
];

// The picker only lets the user pick date/hour/minute, so seconds inherited
// from the moment it opened must not leak into the saved timestamp.
export const toIsoString = (value: moment.Moment) =>
  value.clone().seconds(0).milliseconds(0).toISOString();

export const changeHour = (value: moment.Moment, hour: number) =>
  value.clone().hour(value.hour() >= 12 ? (hour % 12) + 12 : hour % 12);

export const changeMinutes = (value: moment.Moment, minutes: number) =>
  value.clone().minute(minutes);

export const changeAmPm = (value: moment.Moment, nextAmPm: string) => {
  const isPm = value.hour() >= 12;
  const wantsPm = nextAmPm === 'PM';

  if (isPm === wantsPm) {
    return value.clone();
  }

  return value.clone().add(isPm ? -12 : 12, 'hours');
};

export const changeDate = (value: moment.Moment, date: Date) => {
  const nextDate = moment(date);

  return value
    .clone()
    .year(nextDate.year())
    .month(nextDate.month())
    .date(nextDate.date());
};

export const keepWallClock = (
  publishedAt: string,
  fromTimeZone: string,
  toTimeZone: string,
) => toIsoString(moment.tz(publishedAt, fromTimeZone).tz(toTimeZone, true));
